export default __webpack_public_path__ + "static/media/webopt.fa597e80.png";